<template>
  <div>
    <b-row>
      <b-col>
        <h5 class="text-secondary m-1">
          {{ "Order payment type" }}:
          <v-icon v-if="loading" name="spinner" spin></v-icon>
        </h5>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <pie-chart
          :chart-data="testData"
          style="postition: relative;"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";

export default {
   props: {
    range: {
      type: Array,
      default: () => (
        [null, null]
      )
    }
  },
  components: {
    "pie-chart": () =>
      import("@/components/common/charts/PieChart.vue"),
  },
  data() {
    return {
      loading: false,
      testData: {
        labels: [
          "Invoice",
          "Exact",
          "Mollie"
        ],
        datasets: []
      }
    }
  },
  methods: {
    ...mapActions("axios_mod", ["simpleFetch"]),
    ...mapMutations(["setShowLoadingModal"]),
    fetchData() {
      const data = {
        query: `
          query {
            OrderPaymentTypeChart (
              ${ this.range[0]
                ? 'from: "' +this.range[0] + '", to: "' + this.range[1] + '"'
                : ''
              }
            )
          }
        `
      };
      this.loading = true;
      this.simpleFetch({data, this_ref: this}).then((res) => {
        if (res) {
          let newData = {
            labels: [...this.testData.labels],
            datasets: JSON.parse(res.OrderPaymentTypeChart)
          }
          this.testData = newData;
        }
      }).finally(() => {
        this.loading = false;
      })  
    }
  },
  computed: {
    ...mapGetters(["getUserSystem"])
  },
  watch: {
    getUserSystem: function() {
      this.fetchData();
    },
    range: function() {
      this.fetchData();
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>
